import { createFileRoute } from "@tanstack/react-router"
import { Module } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import Charts from "~/pages/development/charts"

export const Route = createFileRoute("/_auth/internal/development/charts")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Module breadcrumb={<BreadcrumbWrapper />}>
      <Charts />
    </Module>
  )
}
